export default __webpack_public_path__ + "static/media/loading.764b4db9.gif";